import React, { useState, useEffect, useContext } from "react";
import { APIProvider } from '@vis.gl/react-google-maps';
import { optionsData, optionsMBMData } from "variables/lists/maps";
import axios from "axios";
import { makeStyles } from "@mui/styles";
import UserService from "services/UserService";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { getMaps, getMapsLocationInfo, getMBMAVOBBoxs, getAccountMeters } from "services/ConfigServices";
import CustomSelectNoColor from "components/Input/CustomSelectNoColor.js";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle";
import tablestyles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { withStyles } from "@mui/styles";
import StandardMapComponent from "./Standard/StandardMapComponent";
import AdvancedMapComponent from "./AdvancedMarkers/AdvancedMapComponent";
import {
  flexMapContainerStyle
} from "assets/jss/material-dashboard-pro-react/views/Maps/MapsStyle";
import CardBody from "components/Card/CardBody";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import { ShowDataGrid as ShowDataGridSites } from "./Standard/ShowDataGrid";
import { ShowDataGrid as ShowDataGridMeters } from "./AdvancedMarkers/Meters/ShowDataGrid";
import { ShowMarkerCard as ShowMarkerCardSites } from "./Standard/ShowMarkerCard";
import { ShowMarkerCard as ShowMarkerCardMeters } from "./AdvancedMarkers/Meters/ShowMarkerCard";
import { energyData } from "variables/lists/meters";
import Button from "components/CustomButtons/Button";
import CloseIcon from '@mui/icons-material/Close';
import {energy2Data} from "variables/lists/meters";
import { isArray } from "lodash";

const cardHeaderStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  marginTop: "5px",
  marginBottom: "-5px"
};
const mapcardHeaderStyle = {
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  marginTop: "5px",
  marginBottom: "-5px"
};

const Ecowatt = styled.div`

`;

const FlexContainer = styled.div`
  margin-top: 10px;
`;


const ToolBar = styled.div`
  display: flex;
  justify-content: space-between;
`;

const ToolBarRight = styled.div`
  display: flex;
`;

const useTableStyles = makeStyles(tablestyles);
const useStyles = makeStyles(styles);
const useStyles2 = makeStyles((theme) => ({
  planicon: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planicongreen: {
    display: 'block',
    position: 'absolute',
    cursor: 'pointer',
    color: "#91C73C",
    background: '#ffffffd6',
    borderRadius: 10,
  },
  planmenu: {
    display: 'flex',
    aligItems: "flex-end",
  },
  plansubmenu: {
    display: 'flex',
    marginTop: 7,
    marginLeft: 5,
  },
  planmenuicon: {
    width: "20px",
    height: "20px",
  },
  planmenubutton: {
    background: "#FFFFFF"
  },
  planmenubuttonpressed: {
    background: "#91C73C"
  },
}));

const setNotification = (status, text) => {
  if (status === "success") {
    NotificationManager.success(text);
  } else {
    NotificationManager.error(text);
  }
};
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);


const columns = [
  {
    name: "Nom",
    sortable: true,
    selector: (row) => row.name,
    cell: (row) => row.name,
  },
];

const columnsmeters = [
  {
    id: 1,
    name: "Identifiant",
    sortable: true,
    selector: (row) => row.properties?.name,
    cell: (row) => row.properties?.name,
  },
  {
    id: 2,
    name: "Type",
    sortable: true,
    selector: (row) => row.properties?.energy ? energyData.find((f) => f.id === row.properties.energy).name : '',
    cell: (row) => row.properties?.energy ? energyData.find((f) => f.id === row.properties.energy).name : '',
  },
];

const MapContainer = () => {
  const classes = useStyles();
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_geb_access = permis.includes("mbm_geb_access");
  const mbm_access = permis.includes("mbm_access");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setOutofcontextclic, setChartIdGroup, setSelectedNodesInfo } = appContext;

  const [selectedOption, setSelectedOption] = useState("1")
  const [metersfilters, setMetersfilters] = useState([]);

  const [data, setData] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState([]);
  const [mapCenter, setMapCenter] = useState([]);
  const [showInfoWindow, setShowInfoWindow] = useState([]);
  const [activeMarker, setActiveMarker] = useState([]);
  const [rows, setRows] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [activeSiteId, setActiveSiteId] = useState(null);
  const [overSiteId, setOverSiteId] = useState([]);

  const [filteredrows, setFilteredrows] = useState([]);
  const [bouncingdest, setBouncingdest] = useState(null);


  const [activesite, setActivesite] = useState();


  const handleSelectedOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setActiveMarker({});
    setSelectedPlace({});
  };
  const handleMetersfiltersChange = (event) => { setMetersfilters(event.target.value); };

  //flex list
  useEffect(() => {
    getMap();
  }, [chartIdGroup, selectedOption]);




  const handleMarkerClick = (destination) => {
    console.log(destination);
    var locationinfo = {};
    locationinfo.name = destination.text;
    locationinfo.id = destination.id;
    locationinfo.type = destination.type;
    locationinfo.subtype = destination.subtype;
    locationinfo.lat = destination.location.lat;
    locationinfo.lng = destination.location.lng;
    setSelectedPlace(locationinfo);
    setActivesite(destination);
    setShowInfoWindow(true);
    setMapCenter({ lat: destination.location.lat, lng: destination.location.lng });
    setActiveSiteId(destination.id);
    setOverSiteId(null);
  }

  const onRowOut = (rowParams, event) => {
    if (showInfoWindow == false) {
      setOverSiteId(null);
    }
  };

  const onRowOver = (rowParams, event) => {
    if (showInfoWindow == false) {
      setOverSiteId(rowParams.id);
    }
  };

  const onCloseMeterCard = (props) => {
    setActiveSiteId(null);
  };

  const onRowMeterClick = (rowParams, event) => {
    setActiveSiteId(rowParams.id);
  }

  const onSelectionClick = (id, name) => {
    let idgroup = "" + id;;
    setOutofcontextclic(idgroup);
    setChartIdGroup(idgroup);
    setSelectedNodesInfo(name);
  };

  const onClose = (props) => {
    if (showInfoWindow) {
      setShowInfoWindow(false);
      setActiveMarker({});
      setSelectedPlace({});
      setActiveSiteId(null);
      setActivesite(null);
      setOverSiteId(null);
    }
  };

  const onRowClick = (rowParams, event) => {
    console.log(rowParams);
    var locationinfo = {};
    locationinfo.name = rowParams.name;
    locationinfo.id = rowParams.id;
    locationinfo.type = rowParams.marker.destination.type;
    locationinfo.subtype = rowParams.marker.destination.subtype;
    locationinfo.lat = rowParams.marker.destination.location.lat;
    locationinfo.lng = rowParams.marker.destination.location.lng;

    setSelectedPlace(locationinfo);
    setActivesite(rowParams.marker.destination);
    setActiveMarker(rowParams.marker);
    setShowInfoWindow(true);
    setMapCenter({ lat: rowParams.marker.destination.location.lat, lng: rowParams.marker.destination.location.lng });
    setActiveSiteId(rowParams.id);
    setOverSiteId(null);
    //this.getMapLocationInfo(rowParams.row.marker.props, rowParams.row.marker, event); todo
    //this.reBuildMarkers(rowParams.row.marker.props.site.id, null) todo
  };


  const getMap = () => {
    console.log(chartIdGroup,chartIdGroup[0].length);
    if (chartIdGroup > 0 || chartIdGroup[0].length > 1) {
      let option = optionsData.find((o) => o.id === selectedOption);
      if (selectedOption === 'meters') {
        axios.get(getAccountMeters(null, 'all', chartIdGroup, 'meterstable'), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
          .then((response) => {
            if (selectedOption === 'meters') {
              var rowsTmp = [];
              var markersTmp = [];
              response.data.meters.map((destination, i) => {
                let newdestination = { ...destination };
                if (destination.details?.validatedAddress?.geometry?.location) {
                  newdestination.location = destination.details.validatedAddress.geometry.location;
                  newdestination.text = destination.meternumber;
                  var marker = { option, destination: newdestination };
                  markersTmp.push(marker);
                  rowsTmp.push({ id: destination.id, name: destination.meternumber, marker: marker, energy: destination.energy })
                }
              })
              setData(response.data.meters);
              setRows(rowsTmp);
              setMarkers(markersTmp);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
      else if (selectedOption === '10') {
        axios.get(getMBMAVOBBoxs(chartIdGroup, "gateways"), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
          .then((response) => {
            if (selectedOption === '10') {
              var rowsTmp = [];
              var markersTmp = [];
              response.data.avobboxs.map((destination, i) => {
                let newdestination = { ...destination };
                if (destination.otherparameters?.validatedaddress?.geometry?.location) {
                  newdestination.location = destination.otherparameters.validatedaddress.geometry.location;
                  newdestination.text = destination.name;
                  var marker = { option, destination: newdestination };
                  markersTmp.push(marker);
                  rowsTmp.push({ id: destination.id, name: destination.name, marker: marker })
                }
              })
              setData(response.data.avobboxs);
              setRows(rowsTmp);
              setMarkers(markersTmp);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
      else {
        axios.get(getMaps(selectedOption, chartIdGroup, "allsites"), {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
          .then((response) => {
            if (selectedOption !== '10' && selectedOption !== 'meters') {
              var rowsTmp = [];
              var markersTmp = [];
              response.data.data.sitelist.map((destination, i) => {
                var marker = { option, destination };
                markersTmp.push(marker);
                rowsTmp.push({ id: destination.id, name: destination.text, marker: marker })
              })

              setData(response.data.data.sitelist);
              setRows(rowsTmp);
              setMarkers(markersTmp);
            }
          })
          .catch((error) => {
            console.error(error);
          });

        ;
      }
    }
  }


  return (
    <FlexContainer>
      <GridContainer sx={{ height: 0.99 }} alignContent="flex-start">
        {/* <GridItem xs={12} sm={12} md={12} lg={12}>
          <ToolBar>
            <div style={{ display: "flex" }}>
              toolbar
            </div>
            <ToolBarRight>

            </ToolBarRight>
          </ToolBar>
        </GridItem> */}
        <GridItem xs={12} sm={12} md={(selectedOption === '10') ? 12 : 9} lg={(selectedOption === '10') ? 12 : 9}>
          <Card raised={false} chart style={{ marginTop: '10px', marginBottom: '5px', background: '#242f3e' }}>
            <CardHeader color="success" icon style={mapcardHeaderStyle}>
              <div style={{ display: "flex" }}>
                {/* <SmartGrid2 style={{ marginTop: "5px" }} /> */}
                <h4 className={classes.cardIconTitleSimpleCardDark}>{"Carte"}</h4>
              </div>
              {
                selectedOption === 'meters' ?
                  <CustomSelectNoColor
                    marginTop={15}
                    width={200}
                    inputTitle={"Filtres"}
                    selectValue={metersfilters}
                    handleSelectValueChange={handleMetersfiltersChange}
                    data={energy2Data}
                    small
                    multiple
                  /> : <></>
              }
              <CustomSelectNoColor
                marginTop={15}
                width={200}
                inputTitle={"Type d'entités affichées"}
                selectValue={selectedOption}
                handleSelectValueChange={handleSelectedOptionChange}
                data={(mbm_geb_access || mbm_access) ? optionsMBMData : optionsData}
                small
              />
            </CardHeader>
            <CardBody style={{ height: '100%', userSelect: 'none' }} id={"4654655"}>
              <div style={flexMapContainerStyle} className="flexmap">
                <APIProvider apiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
                  {(selectedOption === '10' || selectedOption === 'meters') ?
                    <AdvancedMapComponent
                      markersraw={markers}
                      onMarkerClickCallback={handleMarkerClick}
                      activeSiteId={activeSiteId}
                      overSiteId={overSiteId}
                      selectedOption={selectedOption}
                      filteredrows={filteredrows}
                      setFilteredrows={setFilteredrows}
                      bouncingdest={bouncingdest}
                      setActiveSiteId={setActiveSiteId}
                      metersfilters={metersfilters}
                    ></AdvancedMapComponent> :
                    <StandardMapComponent
                      markersraw={markers}
                      onMarkerClickCallback={handleMarkerClick}
                      activeSiteId={activeSiteId}
                      overSiteId={overSiteId}
                      selectedOption={selectedOption}
                    ></StandardMapComponent>

                  }
                </APIProvider>
              </div>
            </CardBody>
          </Card>
        </GridItem>
        {
          (selectedOption === '10') ?
            <>
            </> :
            (selectedOption === 'meters') ?
              <>
                <GridItem xs={12} sm={12} md={3} lg={3} >
                  <GridContainer sx={{ height: 0.99 }} alignContent="flex-start">

                    {
                      activeSiteId ?
                        <GridItem xs={12} sm={12} md={12} lg={12} style={{ height: '100%' }}>
                          <Card raised={false} chart style={{ marginTop: '10px', marginBottom: '40px', background: '#242f3e', height: '99%' }}>
                            <CardHeader color="success" icon style={cardHeaderStyle}>
                              <h4 className={classes.cardIconTitleSimpleCardDark}>{"Détails du compteur"}</h4>
                              <Button onClick={onCloseMeterCard} justIcon size={'sm'} simple>
                                <CloseIcon />
                              </Button>
                            </CardHeader>
                            <CardBody style={{ height: '370px', userSelect: 'none' }} id={"4654654"}>
                              <ShowMarkerCardMeters
                                onClose={onCloseMeterCard}
                                meterid={activeSiteId}
                                meters={data}
                              />
                            </CardBody>
                          </Card>
                        </GridItem>
                        :
                        <GridItem xs={12} sm={12} md={12} lg={12} style={{ height: '100%' }}>
                          <Card raised={false} chart style={{ marginTop: '10px', marginBottom: '5px', background: '#242f3e', height: '99%' }}>
                            {/* <CardHeader color="success" icon style={cardHeaderStyle}>
                            <Timeline style={{ marginTop: "5px" }} />
                            <h4 className={classes.cardIconTitleSimpleCardDark}>{"Tableau"}</h4>
                          </CardHeader> */}
                            <CardBody style={{ userSelect: 'none', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: "10px 0 0 0" }} id={"4654654"}>
                              <ShowDataGridMeters
                                columns={columnsmeters}
                                rows={filteredrows}
                                onRowClick={onRowMeterClick}
                                onRowOver={onRowOver}
                                onRowOut={onRowOut}
                              />
                            </CardBody>
                          </Card>
                        </GridItem>
                    }
                  </GridContainer>
                </GridItem>

              </>
              : <>
                <GridItem xs={12} sm={12} md={3} lg={3} >
                  <GridContainer sx={{ height: 0.99 }} alignContent="flex-start">

                    {
                      activesite ?
                        <GridItem xs={12} sm={12} md={12} lg={12} style={{ height: '100%' }}>
                          <Card raised={false} chart style={{ marginTop: '10px', marginBottom: '40px', background: '#242f3e', height: '99%' }}>
                            <CardHeader color="success" icon style={cardHeaderStyle}>
                              {/* <Timeline style={{ marginTop: "5px" }} /> */}
                              <h4 className={classes.cardIconTitleSimpleCardDark}>{"Infos de " + activesite.text}</h4>
                              <Button onClick={onClose} justIcon size={'sm'} simple>
                                <CloseIcon />
                              </Button>
                            </CardHeader>
                            <CardBody style={{ height: '370px', userSelect: 'none' }} id={"4654654"}>
                              <ShowMarkerCardSites
                                onClose={onClose}
                                locationInfo={selectedPlace}
                                onSelectionClick={() => onSelectionClick(selectedPlace.id, selectedPlace.name)}
                              />
                            </CardBody>
                          </Card>
                        </GridItem>
                        :
                        <GridItem xs={12} sm={12} md={12} lg={12} style={{ height: '100%' }}>
                          <Card raised={false} chart style={{ marginTop: '10px', marginBottom: '5px', background: '#242f3e', height: '99%' }}>
                            {/* <CardHeader color="success" icon style={cardHeaderStyle}>
                            <Timeline style={{ marginTop: "5px" }} />
                            <h4 className={classes.cardIconTitleSimpleCardDark}>{"Tableau"}</h4>
                          </CardHeader> */}
                            <CardBody style={{ userSelect: 'none', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: "10px 0 0 0" }} id={"4654654"}>
                              <ShowDataGridSites
                                columns={columns}
                                rows={rows}
                                onRowClick={onRowClick}
                                onRowOver={onRowOver}
                                onRowOut={onRowOut}
                              />
                            </CardBody>
                          </Card>
                        </GridItem>
                    }

                  </GridContainer>
                </GridItem>
                : <></>

              </>
        }

      </GridContainer>
      <NotificationContainer />
    </FlexContainer>
  );
};

export default MapContainer;
